export default __webpack_public_path__ + "static/media/landing_page_image.2839fbf8.png";